/**
 * Abgabe-Vorschau je Variante: Gewicht × Kunststoffanteil × Satz (Σ Kategorien).
 * Konservative Rechnung — volle Kunststoffmasse je gewählter Kategorie.
 */
import { AlertTriangle } from 'lucide-react';
import { abgabeProStueck, formatAbgabe } from '@/lib/ewk';
import { formatGewicht } from '@/lib/grundpreis';
import { parseDecimal } from '@/lib/productEditorModel';

export default function EwkAbgabeVorschau({ rows, schluessel, anteilProzent, kategorien }) {
  if (schluessel.length === 0) return null;
  const anteil = parseDecimal(anteilProzent);
  const results = rows.map((row) => ({
    row,
    res: abgabeProStueck({
      gewichtKg: parseDecimal(row.gewicht_kg),
      anteilProzent: Number.isFinite(anteil) && anteil != null ? anteil : 100,
      schluessel,
      kategorien,
    }),
  }));
  const warnungen = [];
  if (results.some((r) => r.res.fehltGewicht)) warnungen.push('Gewicht fehlt bei mindestens einer Variante.');
  if (results.some((r) => r.res.unvollstaendig)) warnungen.push('Für mindestens eine Kategorie ist kein Abgabesatz hinterlegt.');

  return (
    <div className="space-y-2">
      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
        <div className="grid grid-cols-[1fr_90px_110px] gap-2 px-3 py-2 bg-slate-100 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
          <span>Variante</span><span className="text-right">Gewicht</span><span className="text-right">Abgabe/Stück</span>
        </div>
        <div className="divide-y divide-slate-100">
          {results.map(({ row, res }) => (
            <div key={row._key} className="px-3 py-2 text-sm">
              <div className="grid grid-cols-[1fr_90px_110px] gap-2 items-center">
                <span className="truncate">{row.title || row.sku || 'Variante'}</span>
                <span className="text-right tabular-nums text-slate-600">{formatGewicht(parseDecimal(row.gewicht_kg))}</span>
                <span className="text-right font-mono tabular-nums text-brand-950">{res.fehltGewicht ? '—' : formatAbgabe(res.gesamt)}</span>
              </div>
              {!res.fehltGewicht && res.positionen.length > 1 && (
                <ul className="mt-1 space-y-0.5 text-[11px] text-slate-400">
                  {res.positionen.map((p) => (
                    <li key={p.schluessel} className="grid grid-cols-[1fr_110px] gap-2">
                      <span className="truncate">{p.name}{p.satz == null ? ' (Satz fehlt)' : ''}</span>
                      <span className="text-right tabular-nums">{formatAbgabe(p.betrag)}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
      {warnungen.map((w) => (
        <p key={w} className="flex items-center gap-1.5 text-[11px] text-amber-700"><AlertTriangle className="w-3.5 h-3.5" /> {w}</p>
      ))}
      <p className="text-[11px] text-slate-400">Konservative Rechnung: volle Kunststoffmasse je gewählter Kategorie. Meldung jährlich bis 15. Mai über DIVID.</p>
    </div>
  );
}
